export default{
  payment_method : [
    {id: 2, name: "Maybank", img:"mbb", type:"normal"},
    {id: 3, name: "CIMB Bank", img:"cimb", type:"normal"},
    {id: 5, name: "Public Bank", img:"pbb", type:"normal"},
    {id: 6, name: "RHB Bank", img:"rhb", type:"normal"},
    {id: 7, name: "Alliance Bank", img:"alb", type:"normal"},
    {id: 11, name: "Hong Leong Bank", img:"hlb", type:"normal"},
    {id: 15, name: "Bank Islam", img:"bi", type:"normal"},
    {id: 19, name: "Affin Bank", img:"afb", type:"normal"},
    {id: 2105, name: "Touch N Go Pin", img:"tng", type:"normal"},
    {id: 101, name: "Touch N Go", img:"tng", type:"normal"},
    {id: 102, name: "GrabPay", img:"grab", type:"normal"},
    {id: 103, name: "ShopeePay", img:"sp", type:"normal"},
    {id: 104, name: "Boost", img:"boost", type:"normal"},
    {id: 105, name: "DuitNow", img:"dn", type:"normal"},
    {id: "TUSDT", name:"USDT-TRC", img:"usdt", type:"normal"},
    {id: 2101, name: "Digi", img:"digi", type:"pin"},
    {id: 2102, name: "Maxis", img:"mx", type:"pin"},
    {id: 2103, name: "Celcom", img:"cc", type:"pin"},
    {id: 2104, name: "UMobile", img:"um", type:"pin"},
    // {id: 2105, name: "Touch N Go", img:"tng", type:"pin"}
    
  ]
}